import Types from '../types/activityFeed';

const initialState = {
  activityFeed: {
    loading: false,
    data: [],
    meta: {},
    error: '',
    requestId: 0,
  },
};

const isCurrentRequest = (state, requestId) =>
  requestId == null || requestId === state.activityFeed.requestId;

export default function ActivityFeed(state = initialState, action) {
  switch (action.type) {
    case Types.GET_ACTIVITY_FEED_REQUEST:
      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          loading: true,
          requestId: action.payload?.requestId,
        },
      };
    case Types.GET_ACTIVITY_FEED_SUCCESS: {
      if (!isCurrentRequest(state, action.payload?.requestId)) {
        return state;
      }
      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          loading: false,
          data: action.payload?.isMore
            ? [
                ...(state.activityFeed.data || []),
                ...(action.payload?.data || []),
              ]
            : action.payload?.data || [],
          meta: action.payload?.meta || {},
          error: '',
        },
      };
    }

    case Types.GET_ACTIVITY_FEED_ERROR: {
      if (!isCurrentRequest(state, action.payload?.requestId)) {
        return state;
      }
      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          loading: false,
          data: [],
          meta: {},
          error: action.payload?.error ?? action.payload,
        },
      };
    }
    default:
      return state;
  }
}
